<template>
  <div style="position: relative;">
    <el-form ref="specialistFilter" :model="specialist" :size="defaultFormItemSize"
             label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="名称" prop="formFilter.specialistName">
          <el-input class="filter-item" v-model="specialist.formFilter.specialistName"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="类型" prop="formFilter.specialistType">
          <el-select class="filter-item" v-model="specialist.formFilter.specialistType" :clearable="true" filterable
                     placeholder="" :loading="specialist.specialistType.impl.loading"
                     @visible-change="specialist.specialistType.impl.onVisibleChange"
                     @change="onSpecialistTypeValueChange">
            <el-option v-for="item in specialist.specialistType.impl.dropdownList" :key="item.id"
                       :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="是否委派" prop="formFilter.appointFlag">-->
        <!--          <el-select class="filter-item" v-model="specialist.formFilter.appointFlag" :clearable="true" filterable-->
        <!--            placeholder="" :loading="specialist.appointFlag.impl.loading"-->
        <!--            @visible-change="specialist.appointFlag.impl.onVisibleChange"-->
        <!--            @change="onAppointFlagValueChange">-->
        <!--            <el-option v-for="item in specialist.appointFlag.impl.dropdownList" :key="item.id"-->
        <!--              :value="item.id" :label="item.name"-->
        <!--            />-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetSpecialist">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshSpecialist(true)">查询</el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="specialist" :data="specialist.Specialist.impl.dataList" :size="defaultFormItemSize" @sort-change="specialist.Specialist.impl.onSortChange"
                  header-cell-class-name="table-header-gray"
                  highlight-current-row @current-change="specialist.Specialist.impl.currentRowChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="specialist.Specialist.impl.getTableIndex" />
          <el-table-column label="名称" prop="specialistName">
          </el-table-column>
          <el-table-column label="类型" prop="specialistTypeDictMap.name">
          </el-table-column>
          <el-table-column label="联系电话" prop="mobilePhone">
          </el-table-column>
          <el-table-column label="照片" min-width="100px">
            <template slot-scope="scope">
              <el-image v-for="item in parseUploadData(scope.row.specialistAvatar, {id: scope.row.id, fieldName: 'specialistAvatar', asImage: true})"
                        :preview-src-list="getPictureList(scope.row.specialistAvatar, {id: scope.row.id, fieldName: 'specialistAvatar', asImage: true})"
                        class="table-cell-image" :key="item.url" :src="item.url" fit="fill">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="认证时间" prop="createTime">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="getTemplateRow(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="specialist.Specialist.impl.totalCount"
            :current-page="specialist.Specialist.impl.currentPage"
            :page-size="specialist.Specialist.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="specialist.Specialist.impl.onCurrentPageChange"
            @size-change="specialist.Specialist.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
  import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
  import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
  import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
  import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
  import { SpecialistController, DictionaryController } from '@/api';

export default {
  name: 'specialistSelect',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      hotFlag: true,
      value: '1',
      specialist: {
        formFilter: {
          specialistName: undefined,
          specialistType: undefined,
          appointFlag: undefined
        },
        formFilterCopy: {
          specialistName: undefined,
          specialistType: undefined,
          appointFlag: undefined
        },
        Specialist: {
          impl: new TableWidget(this.loadSpecialistWidgetData, this.loadSpecialistVerify, true, true, 'createTime', 1)
        },
        specialistType: {
          impl: new DropdownWidget(this.loadSpecialistTypeDropdownList)
        },
        appointFlag: {
          impl: new DropdownWidget(this.loadAppointFlagDropdownList)
        },
        isInit: false
      }
    }
  },
  methods: {

    // 选择后回调
    getTemplateRow (row) {
      this.onCancel(true, row);
    },
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    onResetSpecialist () {
      this.$refs.specialistFilter.resetFields();
      this.refreshSpecialist(true);
    },
    /**
       * 专家主表数据获取函数，返回Promise
       */
    loadSpecialistWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        specialistDtoFilter: {
          auditStatus: this.AuditStatusDict.SHTG,
          specialistName: this.specialist.formFilter.specialistName,
          specialistType: this.specialist.formFilter.specialistType
        }
      }
      return new Promise((resolve, reject) => {
        SpecialistController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.specialist.Specialist.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.specialist.Specialist.impl.currentRow.id, 'id');
              this.$refs.specialist.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 专家主表数据获取检测函数，返回true正常获取数据，返回false停止获取数据
       */
    loadSpecialistVerify () {
      return true;
    },
    /**
       * 类型下拉数据获取函数
       */
    loadSpecialistTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSpecialistTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 类型选中值改变
       */
    onSpecialistTypeValueChange (value) {
    },
    /**
       * 是否委派下拉数据获取函数
       */
    loadAppointFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 是否委派选中值改变
       */
    onAppointFlagValueChange (value) {
    },
    /**
       * 更新专家管理
       */
    refreshSpecialist (reloadData = false) {
      if (reloadData) {
        this.specialist.Specialist.impl.refreshTable(true, 1);
      } else {
        this.specialist.Specialist.impl.refreshTable();
      }
      if (!this.specialist.isInit) {
        // 初始化下拉数据
      }
      this.specialist.isInit = true;
    },
    onResume () {
      this.refreshSpecialist();
    },
    initFormData () {
    },
    formInit () {
      this.refreshSpecialist();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
